import type { ComponentProps } from 'react';
import React from 'react';

import Icon from 'common/components/Icon';

const NEW_ICON_SIZE = 24;

const iconStyles: Partial<ComponentProps<typeof Icon>> = {
  fill: 'sys.neutral.icon.default',
  role: 'presentation',
  size: NEW_ICON_SIZE,
};

export const Account = (props: ComponentProps<typeof Icon>) => (
  <Icon name="accountH24Large" {...iconStyles} {...props} />
);

export const Wishlist = (props: ComponentProps<typeof Icon>) => (
  <Icon name="wishlistV2Large" {...iconStyles} {...props} />
);

export const Cart = (props: ComponentProps<typeof Icon>) => (
  <Icon name="cartH24V2Large" {...iconStyles} {...props} />
);
